import type { MenuLinkBasicProps, MenuLinksBasicProps } from '.'
import { MenuLink } from '.'

import { Button } from '@/components/atoms/Button'
import { ArrowCircleIcon } from '@/components/atoms/Icons'
import { MenuIcon } from '@/components/atoms/Icons/MenuIcon'
import { ScrollArea } from '@/components/atoms/ScrollArea'
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetOverlay,
  SheetTrigger,
} from '@/components/atoms/Sheet'
import { trackEvent } from '@/utils'
import { APP_URL } from '@vaultsfyi/common'
import { ExpandableLinkGroup } from './ExpandableLinkGroup'

interface Props {
  links: Array<MenuLinkBasicProps | MenuLinksBasicProps>
}

export const MobileNavigation = ({ links }: Props) => {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="default" size="default" className="inline-block lg:hidden">
          <MenuIcon className="size-6" />
        </Button>
      </SheetTrigger>
      <SheetOverlay className="lg:hidden" />
      <SheetContent className="grid grid-rows-[auto_1fr_auto] lg:hidden">
        <SheetHeader>
          <SheetClose />
        </SheetHeader>
        <ScrollArea className="h-full">
          <div className="flex flex-col gap-2 px-4 py-2">
            {links.map((link, index) => {
              if ('links' in link) {
                if (link.expandable) {
                  return (
                    <ExpandableLinkGroup
                      links={link.links}
                      title={link.title}
                      icon={link.icon}
                      key={link.title + index}
                    />
                  )
                }
                return link.links.map((link) => <MenuLink key={link.name + index} {...link} />)
              }
              return <MenuLink key={link.name + index} {...link} />
            })}
          </div>
        </ScrollArea>
        <SheetFooter>
          <Button
            className="w-full gap-2 font-bold text-base"
            size="md"
            asChild
            onClick={() => trackEvent({ event: 'App redirect', params: { Source: 'Menu' } })}
          >
            <a href={APP_URL} target="_blank" rel="noreferrer">
              Go to app
              <ArrowCircleIcon size={24} direction="right" />
            </a>
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  )
}
